module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mq-09c19f656772c8f93989b6123655dd91.svg";